<template>
  <div>
    <!-- <div class="left"></div> -->
    <!-- <div class="middle"> -->
    <topWell @checkTab="checkTab" :showNews="true"/>
    <!--  -->
    <business/>
    <!-- 最新动态 -->
    <nextNews />
    <!--业务板块-->
    <operational />
    <!--投资项目-->
    <investment />
    <!--政策法规-->
    <policiesRegulations />
    <!--公示公告-->
    <Formula />
    <!--党建工作-->
    <workOfParty />
    <!--合作伙伴-->
    <partner />
    <!--底部nav-->
    <bottomNav />
    <!-- </div> -->
    <!-- <div class="right"></div> -->
  </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import business from "@/views/topWheel/business.vue";
import nextNews from "@/views/nextNews/nextNews.vue";
import operational from "@/views/operational/operational.vue";
import investment from "@/views/investment/investment.vue";
import policiesRegulations from "@/views/policiesRegulations/policiesRegulations.vue";
import Formula from "@/views/Formula/Formula.vue";
import workOfParty from "@/views/workOfParty/workOfParty.vue";
import partner from "@/views/partner/partner.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";

export default {
  name: "HomeView",
  components: {
    topWell,
    nextNews,
    operational,
    investment,
    policiesRegulations,
    Formula,
    workOfParty,
    partner,
    bottomNav,
    business
  },
  data() {
    return {
      tabInd: 1,
    };
  },
  methods: {
    checkTab(ind) {
      this.tabInd = ind;
    },
  },
};
</script>
<style>
.main {
  width: 100vw;
  height: 300px;
}
.main > div {
  float: left;
}
.middle {
  background: maroon;
  height: 100%;
  margin-left: 100px;
  margin-right: 100px;
  /* width: calc(100% - 200px); */
}
.left {
  width: 100px;
  height: 100%;
  margin-right: -100px;
  /*background: rgb(206, 166, 58);*/
}
.right {
  width: 100px;
  height: 100%;
  margin-left: -100px;
  /*background: lime;*/
}
</style>
